<div class="container">
  <div class="header">
    <img src="assets/global/logo.png" alt="Codere" />
  </div>
  <div class="content">
    <div class="image-container">
      <img [src]="config.image" alt />
    </div>
    <p class="title">{{ config.title | translate }}</p>
    <p>{{ config.description| translate }}</p>
    <p *ngIf="config.additionalText">{{ config.additionalText | translate }}</p>
    <ion-button expand="full" (click)="handleClick()">{{ config.buttonText | translate }}</ion-button>
  </div>
</div>
